import baseService from './base/base';
import config from './modelConfig.js';
module.exports = config.reduce((sum, item) => {
  sum[item.name] = baseService(item.url);
  return sum;
}, {});
